import { Moon } from "lucide-react";
import { displayStage } from "@/lib/workspace";

const ACCENT = "#4F46E5";
const TINT = "#EEF0FF";
const BORDER = "#C7CCF5";

const fmtDate = (s) => {
  if (!s) return "";
  const [y, m, d] = s.split("-");
  return m && d && y ? `${m}/${d}/${y}` : s;
};

export default function SnoozedColumn({
  cards = [],
  templates = [],
  users = [],
  onOpen,
  idSuffix = "",
  className = "",
  bodyClassName = "",
}) {
  return (
    <div
      data-testid={`snoozed-column${idSuffix}`}
      className={`shrink-0 flex flex-col rounded-lg border bg-white/60 ${className}`}
      style={{ borderColor: BORDER }}
    >
      <div
        className="px-3 py-2.5 flex items-center gap-2 border-b rounded-t-lg"
        style={{ borderColor: BORDER, background: TINT }}
      >
        <span className="h-5 w-5 rounded-full grid place-items-center bg-[#4F46E5] text-white shrink-0">
          <Moon className="h-3 w-3" />
        </span>
        <h3 className="text-[12px] font-extrabold tracking-tight truncate flex-1" style={{ color: ACCENT }}>
          Snoozed
        </h3>
        <span
          className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-white/85 shrink-0"
          style={{ color: ACCENT }}
        >
          {cards.length}
        </span>
      </div>
      <div className={`flex-1 flex flex-col gap-2 min-h-[40px] p-2.5 ${bodyClassName}`}>
        {cards.map((card) => {
          const tpl = templates.find((t) => t.stage_number === card.current_stage);
          const owner = users.find((u) => u.id === card.owner_id);
          return (
            <button
              key={card.id}
              type="button"
              data-testid={`snoozed-card-${card.av_id}${idSuffix}`}
              onClick={() => onOpen?.(card)}
              className="text-left bg-white rounded-md shadow-[0_1px_2px_rgba(15,23,42,0.06)] hover:shadow-[0_4px_12px_rgba(15,23,42,0.10)] transition-all ring-1 ring-[#4F46E5]/15 hover:ring-[#4F46E5]/30 overflow-hidden"
            >
              <div className="p-3 flex flex-col gap-1.5">
                <div
                  className="text-[14px] font-bold tracking-tight text-[#15233B] leading-snug truncate"
                  title={card.full_name}
                >
                  {card.full_name}
                </div>
                <div className="flex items-center gap-2 text-[10px] text-[#15233B]/55 font-mono">
                  <span className="font-bold">{card.av_id}</span>
                  {card.payer_mco && (
                    <>
                      <span>·</span>
                      <span className="font-sans uppercase tracking-[0.12em] text-[#15233B]/50">{card.payer_mco}</span>
                    </>
                  )}
                </div>
                <div className="mt-0.5 flex items-center gap-1 text-[10px] font-semibold text-[#15233B]/70">
                  <span className="h-4 w-4 rounded-full grid place-items-center text-[9px] font-extrabold bg-[#15233B] text-white shrink-0">
                    {displayStage(card.current_stage)}
                  </span>
                  <span className="truncate">Paused · {tpl?.name || `Stage ${displayStage(card.current_stage)}`}</span>
                </div>
                <div className="flex items-center gap-1 text-[10px] font-bold text-[#4F46E5]">
                  <Moon className="h-3 w-3" /> Wakes {fmtDate(card.snoozed_until)}
                </div>
                {card.snooze_reason && (
                  <div className="text-[10px] text-[#15233B]/60 italic leading-snug">“{card.snooze_reason}”</div>
                )}
                <div className="text-[10px] text-[#15233B]/45">
                  Snoozed by {card.snoozed_by_name || "—"}
                  {owner ? ` · Owner ${owner.name}` : ""}
                </div>
              </div>
            </button>
          );
        })}
        {cards.length === 0 && (
          <div className="text-[11px] text-[#15233B]/30 italic py-3 text-center">No snoozed leads</div>
        )}
      </div>
    </div>
  );
}
